<template>
	<div>
		<div
			class="modal fade product-tags"
			id="removeTag"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header" style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">Delete Tag</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click = "hideModal()">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style ="padding-top :25px" v-if="isLoading">
						<div
						class="spinner-border"
						style="margin:40px auto;display:block;"
						></div>
					</div>
					<div class="modal-body" style="margin-top:25px" v-else>

						<div class="form-group row" v-if = "brand_tag && brand_tag.length">
							<div class="col-md-2">
								<label for="name">Brand Tags</label>
							</div>
							<div class = "col-md-5">
								<multiselect
									v-model="brand_tag"
									:options="brand_tag"
									:searchable="true"
									ref="multiselect"
									label="title"
									track-by="title"
									open-direction="bottom"
									deselectLabel
									selectedLabel
									selectLabel
									:disabled = "true"
									:taggable="false"
									placeholder="Add Tags..."
									class="form-control multi-dropdown col-md-12"
									:multiple="false"
									id="keywordTags"
										>
								</multiselect>
							</div>
							<div class="col-md-3" style = "display:flex;align-items:center">
								<input
									type="checkbox"
									v-model="isDelAllBrand"
									value="true"
									style="margin-top:0px"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete = "off"
								>
								<label for="name" style = "margin:0px"> Delete for all products</label>

								<!-- <div class="col-md-8" style = "display: flex;align-items: center;margin:0px">
									<label for="name">Delete all brand tags</label>
								</div>
								<div class="col-sm-3" style = "display: flex;align-items: center;">
									<input
										type="checkbox"
										v-model="isDelAllBrand"
										value="true"
										style="margin-top:0px"
										class="form-check-input"
										id="exampleCheck1"
										autocomplete = "off"
									>
								</div> -->
							</div>
							<div class = "col-md-1" style = "margin:0px">
								<div v-if = "del_brand == 'Loading'" class="spinner-border"></div>
								<button
									v-else
									style="color:white;background-color:red"
									id="delete"
									class="btn btn-primary"
									v-on:click="del_brand!='Deleted'?deleteTag('brand_product'):''"
								>{{del_brand}}</button>
							</div>
						</div>

						<div class="form-group row" v-if = "category_tag && category_tag.length">
							<div class="col-md-2">
								<label for="name">Category Tags</label>
							</div>
							<div class = "col-md-5">
								<multiselect
								    v-model="category_tag"
								    :options="category_tag"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    open-direction="bottom"
									deselectLabel
									selectedLabel
									selectLabel
								    :taggable="false"
									:disabled = "true"
								    placeholder="Add Tags..."
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="keywordTags"
										>
								</multiselect>
							</div>
							<div class="col-md-3 " style = "display:flex;align-items:center">
								<input
									type="checkbox"
									v-model="isDelAllCat"
									value="true"
									style="margin-top:0px"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete = "off"
								>
								<label for="name" style = "margin:0px"> Delete for all products</label>
							</div>
							<div class = "col-md-1" style = "margin:0px">
								<div v-if = "del_cat == 'Loading'" class="spinner-border"></div>
								<button
									v-else
									style="color:white;background-color:red"
									id="delete"
									class="btn btn-primary"
									v-on:click="del_cat!='Deleted'?deleteTag('category_product'):''"
								>{{del_cat}}</button>
							</div>

						</div>
						<div class="form-group row" v-if = "gl_tag && gl_tag.length">
							<div class="col-md-2">
								<label for="name">GL Tags</label>
							</div>
							<div class = "col-md-5">
								<multiselect
									v-model="gl_tag"
									:options="gl_tag"
									:searchable="true"
									ref="multiselect"
									label="title"
									track-by="title"
									deselectLabel
									selectedLabel
									selectLabel
									open-direction="bottom"
									:taggable="false"
									:disabled = "true"
									placeholder="Add Tags..."
									class="form-control multi-dropdown col-md-12"
									:multiple="false"
									id="keywordTags"
										>
								</multiselect>
							</div>
							<div class="col-md-3" style = "display:flex;align-items:center">
								<input
									type="checkbox"
									v-model="isDelAllGl"
									value="true"
									style="margin-top:0px"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete = "off"
								>
								<label for="name" style = "margin:0px"> Delete for all products</label>
							</div>
							<div class = "col-md-1" style = "margin:0px">
								<div v-if = "del_gl == 'Loading'" class="spinner-border"></div>
								<button
									v-else
									style="color:white;background-color:red"
									id="delete"
									class="btn btn-primary"
									v-on:click="del_gl!='Deleted'?deleteTag('gl_tag_product'):''"
								>{{del_gl}}</button>
							</div>
						</div>
						<div class="form-group row" v-if = "pg_tag && pg_tag.length">
							<div class="col-md-2">
								<label for="name">Product Group Tags</label>
							</div>
							<div class = "col-md-5">
								<multiselect
									v-model="pg_tag"
									:options="pg_tag"
									:searchable="true"
									ref="multiselect"
									label="title"
									track-by="title"
									deselectLabel
									selectedLabel
									selectLabel
									open-direction="bottom"
									:taggable="false"
									:disabled = "true"
									placeholder="Pg Tags..."
									class="form-control multi-dropdown col-md-12"
									:multiple="false"
									id="keywordTags"
										>
								</multiselect>
							</div>
							<div class="col-md-3" style = "display:flex;align-items:center">
								<input
									type="checkbox"
									v-model="isDelAllPg"
									value="true"
									style="margin-top:0px"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete = "off"
								>
								<label for="name" style = "margin:0px"> Delete for all products</label>
							</div>
							<div class = "col-md-1" style = "margin:0px">
								<div v-if = "del_pg == 'Loading'" class="spinner-border"></div>
								<button
									v-else
									style="color:white;background-color:red"
									id="delete"
									class="btn btn-primary"
									v-on:click="del_pg!='Deleted'?deleteTag('product_group_tag'):''"
								>{{del_pg}}</button>
							</div>
						</div>
						<div class="form-group row" v-if = "style_tag && style_tag.length">
							<div class="col-md-2">
								<label for="name">Style Tags</label>
							</div>
							<div class = "col-md-5">
								<multiselect
									v-model="style_tag"
									:options="style_tag"
									:searchable="true"
									ref="multiselect"
									label="title"
									track-by="title"
									deselectLabel
									selectedLabel
									selectLabel
									open-direction="bottom"
									:taggable="false"
									:disabled = "true"
									placeholder="Add Tags..."
									class="form-control multi-dropdown col-md-12"
									:multiple="false"
									id="keywordTags"
										>
								</multiselect>
							</div>
							<div class="col-md-3" style = "display:flex;align-items:center">
								<input
									type="checkbox"
									v-model="isDelAllStyle"
									value="true"
									style="margin-top:0px"
									class="form-check-input"
									id="exampleCheck1"
									autocomplete = "off"
								>
								<label for="name" style = "margin:0px"> Delete for all products</label>
							</div>
							<div class = "col-md-1" style = "margin:0px">
								<div v-if = "del_style == 'Loading'" class="spinner-border"></div>
								<button
									v-else
									style="color:white;background-color:red"
									id="delete"
									class="btn btn-primary"
									v-on:click="del_style!='Deleted'?deleteTag('style_product'):''"
								>{{del_style}}</button>
							</div>
						</div>

						
						
						
						
					</div>

					<div class="modal-footer" style = "flex: 0 0 auto">
						<div class="mt-2" style="text-align: center">
							<button type="button" @click="hideModal()" class="btn btn-primary" data-dismiss="modal">Close</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Multiselect from "vue-multiselect";

	export default {
		name: "RemoveTag",
		components: {
			Multiselect
		},
		props:["product"],
		watch:{
			product(){
				this.getTagsList()
			}
		},
		data() {
			return {
				category_tag:[],
				style_tag:[],
				brand_tag:[],
				pg_tag:[],
				gl_tag:[],
				isLoading: false,
				isDelAll:false,
				del_cat:'Delete',
				del_style:'Delete',
				del_brand:'Delete',
				del_gl:'Delete',
				del_pg:'Delete',
				isDelAllBrand: false,
				isDelAllCat: false,
				isDelAllStyle: false,
				isDelAllPg:false,
				isDelAllGl:false
			};
		},
		mounted() {
		},
		computed:{

		},
		methods: {
			getTagsList(){
				let payload = {
					id:this.product.id
				}
				let vm = this;
				this.isLoading = true;
				this.$store.dispatch("product/getTagsInfo", payload).then((res) => {

					res.map((e) => {
						if(e.type == 'category_product'){
							vm.category_tag.push(e)
						}
						if(e.type == 'brand_product'){
							vm.brand_tag.push(e)
						}
						if(e.type == 'style_product'){
							vm.style_tag.push(e)
						}
						if(e.type == "product_group_tag"){
							vm.pg_tag.push(e)
						}
						if(e.type == "gl_tag_product"){
							vm.gl_tag.push(e)
						}
						vm.isLoading = false;
					})
				})
			},
			hideModal(type){
				this.$emit("closeModal", type)
			},
			deleteTag(type){

				let payload = {
					type:type,
					productId:this.product.id,
					productAsin:this.product.asin
				}
				if(type == 'category_product'){
					payload.tagId = this.category_tag[0].tag_id
					payload.tagName =  this.category_tag[0].title
					this.del_cat = 'Loading';
					if(this.isDelAllCat){
						payload.isDelAll = this.isDelAllCat
					}
				}
				else if (type == 'brand_product'){
					payload.tagId = this.brand_tag[0].tag_id;
					payload.tagName =  this.brand_tag[0].title
					this.del_brand = 'Loading';
					if(this.isDelAllBrand){
						payload.isDelAll = this.isDelAllBrand
					}
				}
				else if (type == 'style_product'){
					payload.tagId = this.style_tag[0].tag_id;
					payload.tagName =  this.style_tag[0].title
					this.del_style = 'Loading';
					if(this.isDelAllStyle){
						payload.isDelAll = this.isDelAllStyle
					}
				}
				else if (type == 'product_group_tag'){
					payload.tagId = this.pg_tag[0].tag_id;
					payload.tagName =  this.pg_tag[0].title
					this.del_pg = 'Loading';
					if(this.isDelAllPg){
						payload.isDelAll = this.isDelAllPg
					}
				}
				else if (type == 'gl_tag_product'){
					payload.tagId = this.gl_tag[0].tag_id;
					payload.tagName =  this.gl_tag[0].title
					this.del_gl = 'Loading';
					if(this.isDelAllGl){
						payload.isDelAll = this.isDelAllGl
					}
				}

				let vm = this;
				this.$store.dispatch("product/deleteProductTag", payload).then((res) => {
					if(type == 'category_product'){
						vm.del_cat = 'Deleted';
						vm.isDelAllCat = false;
					}
					else if (type == 'brand_product'){
						vm.del_brand = 'Deleted';
						vm.isDelAllBrand = false;
					}
					else if (type == 'style_product'){
						vm.del_style = 'Deleted';
						vm.isDelAllStyle = false;
					}
					else if(type == 'product_group_tag'){
						vm.del_pg = 'Deleted';
						vm.isDelAllPg = false
					}
					else if(type == 'gl_tag_product'){
						vm.del_gl = 'Deleted';
						vm.isDelAllGl = false
					}
				})
			}
		}
	};
</script>
